(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.nsbforms = {
    attach: function (context, settings) {
      var aktionsform = $('.webform-submission-aktionsformular-form', context)

      if (aktionsform.length) {
        var formId = $('[name="formular_id"]').val();
        var texareaFirst = $('[name="beschreibung_aktion"]')
        var texareaSec = $('[name="weitere_informationen_zur_aktion"]')
        if (formId === 'fonds') {
          texareaFirst.attr('placeholder', 'Bitte beschreibt hier Eure geplante Aktion (wer nimmt woran teilnehmen?)');
          texareaSec.attr('placeholder', 'Erklärt uns, wofür Ihr das Geld in der Aktion braucht. ' +
            'Bei fortlaufenden Aktionen: wie viele jungen Menschen nehmen voraussichtlich insgesamt teil?');
        }
      }
    }
  };

  $(document).ready(function () {

      //---change header if scoll
      $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        var header = $('body.domain_freischwimmen #header');
        var body = $('body.domain_freischwimmen');
        if (scroll >= 20) {
          header.addClass('sticky').removeClass('no-sticky');
          body.addClass('sticky').removeClass('no-sticky');
        } else if (header.hasClass('sticky')) {
          header.addClass('no-sticky').removeClass('sticky');
          body.addClass('no-sticky').removeClass('sticky');
        }
      });

      var searchPage = $('.view-suche-freischwimmen.view-id-suche_freischwimmen')
      if (searchPage.length) {
        var searchButton = $(searchPage).find('.fa-search');
        searchButton.on('click touch', function () {
          $(searchPage).find('.js-form-submit').click();
        });
      }

      // form Umfrage Freischwimmen21
      var formUmfrage = $('form.webform-submission-umfrage-freischwimmen21-form');
      if (formUmfrage.length) {
        var checkboxesKooperation = $('form.webform-submission-umfrage-freischwimmen21-form #edit-formen-kooperation');
        var checkboxNoKooperation = $('[name="nein_wir_kooperieren_nicht_"]')
        checkboxNoKooperation.on('change', function (e) {
          if ($(this)[0].checked) {
            checkboxesKooperation.find('input[type="checkbox"]').prop('checked', false).change().attr('disabled', 'disabled')
          } else {
            checkboxesKooperation.find('input[type="checkbox"]').attr('disabled', false)
          }
        })

        var radioFonts = $('[name="3_1_hat_ihre_organisation_einen_antrag_beim_freischwimmen21_fond"]');
        var radioEdit_3_2 = $('form.webform-submission-umfrage-freischwimmen21-form #edit-3-2-welche-finanzielle-auswirkung-hatte-der-freischwimmen21-fond');
        var radioEdit_3_3 = $('form.webform-submission-umfrage-freischwimmen21-form #edit-3-3-neben-dem-finanziellen-aspekt-welche-weiteren-auswirkungen-a')

        radioFonts.on('change', function (e) {
          if ($(this).val() !== 'Ja') {
            radioEdit_3_2.find('input[type="radio"]').prop('checked', false).change().attr('disabled', 'disabled')
            radioEdit_3_3.find('input[type="checkbox"]').prop('checked', false).change().attr('disabled', 'disabled')
          } else {
            radioEdit_3_2.find('input[type="radio"]').attr('disabled', false)
            radioEdit_3_3.find('input[type="checkbox"]').attr('disabled', false)
          }
        })
      }

    }//document ready
  );//document ready


})(jQuery, Drupal);
